import { render, staticRenderFns } from "./AddEditItem.vue?vue&type=template&id=7b1b29ff&scoped=true&"
import script from "./AddEditItem.vue?vue&type=script&lang=js&"
export * from "./AddEditItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1b29ff",
  null
  
)

export default component.exports